<template>
    <v-dialog v-model="dialog.show" persistent max-width="800px">
        <v-card class="ui-card">
            <div class="ui-card__header">
                <div>
                    <h3 class="ui-section-title">{{ page.title }}</h3>
                    <p class="ui-section-description">Nome, categoria e arquivo do documento do caso.</p>
                </div>
            </div>

            <div class="ui-card__body">
                <v-form ref="form" v-model="dataForm.validForm">
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-text-field dense label="Caso" disabled v-model="dataset.data.name" outlined
                                hide-details="auto">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field dense label="Nome" v-model="dataset.doc.name" outlined
                                hide-details="auto"  :rules="rules">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select dense id="category" :items="dataset.docCategories" label="Categoria (aba do site)"
                                v-model="dataset.doc.client_doc_category_id" item-value="id" item-text="name" outlined
                                hide-details="auto" :rules="rules">
                            </v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select dense v-model="dataset.doc.section" :items="sectionOptions" label="Subcategoria" outlined
                                hide-details="auto" no-data-text="Nenhuma subcategoria nesta categoria">
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-file-input dense accept="image/png, image/jpeg, application/pdf, .csv, application/vnd.ms-excel"
                                prepend-icon="" outlined counter required show-size v-model="fileInputValue"
                                :rules="rules"
                                hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                label="Documento" :clearable="true" @change="onFileSelected($event)"
                                ref="docFile" >
                            </v-file-input>
                        </v-col>
                    </v-row>

                    <v-row v-if="dataset.doc.doc_url">
                        <v-col cols="12">
                            <v-btn type="button" depressed color="primary" outlined :href="dataset.doc.doc_url"
                                target="_blank">Visualizar documento
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </div>

            <div class="ui-card__footer">
                <v-btn outlined @click.native="goBack()" :disabled="dataset.loading || dataset.confirming">Cancelar</v-btn>
                <v-btn v-if="$allowed('save')" @click="saveDocData()" color="primary" depressed :loading="dataset.loading" :disabled="dataset.confirming">Salvar</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>


<script>

import axios from "axios"

export default {
    name: "ClientDocDetailsModal",

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        rules: [],
        fileInputValue: null,
        dataset: {
            sections: {},
            docCategories: [],
            clients: [],
            loading: false,
            confirming: false,
            data: {
                category_id: null
            },
            doc: {
               name: null,
               type: null,
               client_doc_category_id: null,
               file: null,
            }
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
        dialog: {
            show: false,
            resolve: null,
            reject: null,
        },
    }),

    computed: {
        // Subcategorias da categoria escolhida; "Topo da aba" = sem subcategoria.
        sectionOptions() {
            const names = (this.dataset.sections[this.dataset.doc.client_doc_category_id] || []).slice();
            if (this.dataset.doc.section && !names.includes(this.dataset.doc.section)) names.push(this.dataset.doc.section);
            return [{ text: 'Topo da aba (sem subcategoria)', value: null }, ...names.sort((a, b) => a.localeCompare(b, 'pt-BR')).map((name) => ({ text: name, value: name }))];
        },
    },

    watch: {
        // Ao trocar de categoria, a subcategoria escolhida pode nao existir na nova.
        'dataset.doc.client_doc_category_id'(value, oldValue) {
            if (oldValue === undefined || value === oldValue || !this.dataset.doc.section) return;
            if (!(this.dataset.sections[value] || []).includes(this.dataset.doc.section)) this.dataset.doc.section = null;
        },
    },

    methods: {
       
        open() {
            this.dialog.show = true;
           
            if (this.dataset.doc && this.dataset.doc.name !== null && this.dataset.doc.name !== undefined && this.dataset.doc.name !== '') {
                
                this.page.isNew = true;
                this.page.title = 'Editar documento'
                this.dataset.doc.file = null;
                this.fileInputValue = null;
                this.rules = [];
    
            }else{

                this.page.isNew = false;
                this.page.title = 'Adicionar documento'
                this.dataset.doc.file = null;
                this.fileInputValue = null;
                this.rules = [this.$rules.required];
            }      
                        
            return new Promise((resolve, reject) => {
                this.dialog.resolve = resolve;
                this.dialog.reject = reject;
            });
            
        },

        close() {
            this.dialog.resolve();
            this.dialog.show = false;
        },

        goBack() {
            if (this.dataset.loading) return;

            this.dataset.doc = {};
            this.close();
        },

        setData(data, item) {
            this.dataset.data = data;
            this.dataset.docCategories = this.sortDocCategories(data.docCategories || []);
            this.dataset.sections = data.docSections || {};

            if (item) {
                this.dataset.doc = item;
            } else {
                this.dataset.doc = {
                    name: null,
                    type: null,
                    client_doc_category_id: data.selectedDocCategory || (this.dataset.docCategories[0] ? this.dataset.docCategories[0].id : null),
                    section: data.selectedSection || null,
                    file: null,
                };
            }
        },

        sortDocCategories(categories) {
            return categories.slice().sort((a, b) => {
                const aIsOther = this.isOtherDocumentsCategory(a.name);
                const bIsOther = this.isOtherDocumentsCategory(b.name);

                if (aIsOther === bIsOther) return 0;
                return aIsOther ? 1 : -1;
            });
        },

        isOtherDocumentsCategory(name) {
            const normalized = this.normalizeText(name);
            return normalized === 'outros' || normalized === 'outros documentos';
        },

        normalizeText(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },


        openDoc(doc) {
            this.selectedDoc = doc;
            this.dialogViewDoc = true;
        },

        onFileSelected(file) {
            this.dataset.doc.file = file;
        },


        async load() {

            try {
                const result = await axios.get(`/api/admin/client-docs/${this.$route.params.id}`);
         
                const data = result.data.content.data;

                this.dataset.data = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        saveDocData(){
            if (this.dataset.loading || this.dataset.confirming) return;

            this.page.isNew ? this.update() : this.add();

        },

        async add() {
            if (!this.$refs.form.validate()) return;
            if (this.dataset.loading || this.dataset.confirming) return;

            this.dataset.confirming = true;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o documento?',
                title: 'Incluir documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            this.dataset.confirming = false;

            if (!proceedAction) {
                return;
            }

            this.dataset.loading = true;

            const payload = this.buildPayload();
            
            try {
                await axios.post('/api/admin/client-docs', payload);

                this.$dialog.notify.info("Documento salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.closeAfterSuccess()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;
            if (this.dataset.loading || this.dataset.confirming) return;

            this.dataset.confirming = true;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o documento?',
                title: 'Atualizar documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            this.dataset.confirming = false;

            if (!proceedAction) {
                return;
            }

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/admin/client-docs/${this.dataset.doc.id}`, payload);

                this.$dialog.notify.info("Documento salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.closeAfterSuccess()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        closeAfterSuccess() {
            this.dataset.doc = {};
            this.close();
        },

        
        buildPayload() {
            const formData = new FormData()

            if (this.dataset.doc.name)
                formData.append('name', this.dataset.doc.name);

            const selectedCategory = this.dataset.docCategories.find((item) => item.id === this.dataset.doc.client_doc_category_id);

            if (selectedCategory) {
                if (!selectedCategory.is_legacy) {
                    formData.append('client_doc_category_id', selectedCategory.id);
                }

                formData.append('type', selectedCategory.type || this.dataset.doc.type || 4);
            } else if (this.dataset.doc.type) {
                formData.append('type', this.dataset.doc.type);
            }

            formData.append('section', this.dataset.doc.section ? String(this.dataset.doc.section).trim() : '');

            if (this.dataset.doc.id)
                formData.append('id', this.dataset.doc.id);

            if (this.dataset.data.id)
                formData.append('client_id', this.dataset.data.id);

            if (this.dataset.doc.file)
                formData.append('file', this.dataset.doc.file)

            return formData;
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.doc-info{
    color: var(--v-primary-base);
    font-size: 16px;
    font-style: normal;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
